import { usePage } from "@inertiajs/react"

import {
  type AssistantTheme,
  DEFAULT_ASSISTANT_NAME,
  assistantTheme,
} from "@/lib/assistant"
import type { Partner } from "@/types"

// IMP-455: the partner-branded assistant identity for the current account.
// Every client-app surface that renders the assistant (orb, copy, headings)
// reads its name and theme from here — never a hardcoded name. Accounts
// without a partner get the neutral defaults.
export function useAssistant(): { name: string; theme: AssistantTheme } {
  const { partner } = usePage().props as { partner?: Partner | null }

  return {
    name: partner?.assistant_name ?? DEFAULT_ASSISTANT_NAME,
    theme: assistantTheme(partner?.assistant_color),
  }
}
